/* eslint-disable no-prototype-builtins */
import * as React from 'react';
import { connect } from 'react-redux';
import { Navigate } from 'react-router';
import { Row } from 'react-bootstrap';
import { UserHelper } from '../../helpers';
import { ApplicationState } from '../../store';
import { AuthActions } from '../../store/auth';
import routePaths from '../../shared/constants/routePaths';
import './SignIn.scss';


interface ComponentProps {
    authenticating?: boolean;
    idToken?: any;
    isAuthenticated?: boolean;
    applicationState?: ApplicationState;
}

type SignInPageProps =
    ComponentProps
    & typeof mapDispatchToProps;

interface ComponentState {
    showSignInDialog: boolean;
}

class SignInPage extends React.Component<SignInPageProps, ComponentState> {
    constructor(props: Readonly<SignInPageProps>) {
        super(props);

        this.state = {
            showSignInDialog: false,
        };
    }


    ///
    
    componentDidMount() {
        // Check if the user has logged out in the current session
        const isLoggedOut = sessionStorage.getItem('isLoggedOut');

        // Auto trigger sign-in if `isLoggedOut` is NOT set or it's explicitly set to 'false'
        if (!isLoggedOut || isLoggedOut === 'false') {
            console.log('Auto sign-in triggered');
            this.handleAutoSignIn(); // Call sign-in directly
           // window.open('/home')
           // return <Navigate to={routePaths.landingPage} />;
            
        }
    }

    handleAutoSignIn = () => {
        const { idToken } = this.props;

        // Logging to confirm that handleAutoSignIn is called
        console.log('handleAutoSignIn called');

        // Check if `idToken` exists and contains `preferred_username`
        if (idToken && idToken.preferred_username) {
            const username: string = idToken.preferred_username;
            console.log('Signing in with username:', username); // Debug log
            this.props.signIn(username, true); // Call sign-in with username
        } else {
            console.log('Signing in without username'); // Debug log
            this.props.signIn(); // Fallback to basic sign-in without username
        }

        // Clear the isLoggedOut flag after a successful login attempt
        sessionStorage.removeItem('isLoggedOut');
    };
    ///

    

    public render() {
        const { authenticating, applicationState } = this.props;
        let isMsalFrame = false;
        if (window.frames && window.frames.frameElement && window.frames.frameElement.id.indexOf('msalRenewFrame') !== -1) {
            isMsalFrame = true;
        }

        if (isMsalFrame) {
            return null;
        } else if (authenticating) {
            return  <div className="d-flex justify-content-center align-items-center "><div className="display-8  animate-text">Signing in, please wait...</div></div>
        }

        if (applicationState && UserHelper.isInternalUserValid(applicationState)) {
            return <Navigate to={routePaths.landingPage} />;
        }

        return (
            <>
                <React.Fragment>
                    {this.renderSignInSection()}
                </React.Fragment>
            </>
        );
    }

    renderSignInSection() {
        return (
            <div className="sign-in-page d-flex align-items-center justify-content-center">
                <div className="text-center">
                    <div>
                        <div className="header-description">Please sign in to access the CallOut Application.</div>
                    </div >
                </div >
                <Row className="justify-content-center my-2">
                    <button className='btn btn-danger mb-2 col-12' onClick={this.onContinueClick}  >Sign In</button>
                </Row>
            </div >
        );

    }

    private onContinueClick = () => {
        const { idToken } = this.props;
        if (idToken && idToken.hasOwnProperty('preferred_username') && idToken.preferred_username) {
            const username: string = idToken.preferred_username;
            this.props.signIn(username, true);console.log("85");
        } else {
            this.props.signIn();console.log("87");
        }
    };

}

const mapStateToProps = (state: ApplicationState, _ownProps: ComponentProps) => {
    const { internalUser } = state;
    return {
        applicationState: state,
        authenticating: internalUser.authenticating,
        idToken: internalUser.idToken,
        isAuthenticated: internalUser.isAuthenticated,
        requestedPage: internalUser.requestedPage
    };
};

const mapDispatchToProps = {
    initMsal: AuthActions.initMsalAgent,
    signIn: AuthActions.signIn,
    requestedPageSet: AuthActions.requestedPageSet
};

export default connect(mapStateToProps, mapDispatchToProps)(SignInPage as any);
